import { Outlet } from 'react-router-dom';
import React from 'react';
import Header from './components/ui/Header';
import Footer from './components/ui/Footer';

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Outlet /> {/* This is where route content will render */}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;